import styled, { keyframes } from 'styled-components';

const slideInRight = keyframes`
  from {
    transform: translateX(20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

// Antes a barra de confirmacao tinha left: 300 + right: 300 (largura
// ~viewport - 600px) e cobria a area central do equipamento, dificultando
// ao operador ver o efeito visual do setpoint. Agora e uma "toast" estreita
// no canto inferior direito, deixando todo o equipamento visivel.
export const ConfirmContainer = styled.div`
  padding: 12px 18px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors.card};
  border: 1px solid ${(props) => props.theme.colors.lightblue};
  position: fixed;
  z-index: 10;
  bottom: 20px;
  right: 20px;
  width: 320px;
  max-width: calc(100vw - 40px);
  box-shadow: none;
  animation: ${slideInRight} 220ms ease-out;

  h3 {
    font-size: 13px;
    font-weight: 700;
    margin: 0;
    color: ${(props) => props.theme.colors.darkerblue};
    line-height: 1.3;
  }

  /* Linha com os 2 botoes lado a lado embaixo do texto */
  > div {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }
`;
